import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recommend-edit-receive-announce rounded-base-middle" }
const _hoisted_2 = { class: "recommend-edit-receive-announce__showing-controller showing-controller" }
const _hoisted_3 = { class: "showing-controller__title" }
const _hoisted_4 = { class: "showing-controller__state-icon" }
const _hoisted_5 = { class: "recommend-edit-receive-announce__announce-table-container announce-table-container" }
const _hoisted_6 = { class: "announce-table-container__editable-infos-controller-container table-infos-controller-container" }
const _hoisted_7 = { class: "table-infos-controller-container__sequence-buttons" }
const _hoisted_8 = { class: "table-infos-controller-container__show-all-announce" }
const _hoisted_9 = { class: "announce-table-container__table-container table-container" }
const _hoisted_10 = { class: "table-container__announce-table-area announce-table-area" }
const _hoisted_11 = { class: "announce-table-area__table-head--container" }
const _hoisted_12 = { class: "announce-table-area__table-head--row" }
const _hoisted_13 = { class: "announce-table-area__table-head--column" }
const _hoisted_14 = { class: "announce-table-area__table-body" }
const _hoisted_15 = { class: "announce-table-area__table-body--row" }
const _hoisted_16 = { class: "announce-table-area__table-body--column" }
const _hoisted_17 = { class: "announce-table-area__table-body--row" }
const _hoisted_18 = { class: "announce-table-area__table-body--column" }
const _hoisted_19 = { class: "table-container__announce-default-item" }
const _hoisted_20 = { class: "table-container__announce-default-item--value" }
const _hoisted_21 = { class: "recommend-edit-receive-announce__editable-infos-container editable-infos-container" }
const _hoisted_22 = { class: "editable-infos-container__editable-infos-announce-adjustment-container editable-infos-announce-adjustment-container" }
const _hoisted_23 = { class: "recommend-edit-receive-announce__editable-infos-lead-time-container editable-infos-lead-time-container" }
const _hoisted_24 = { class: "editable-infos-lead-time-container__title" }
const _hoisted_25 = { class: "editable-infos-lead-time-container__lead-time--value" }
const _hoisted_26 = { class: "recommend-edit-receive-announce__editable-infos-std-container editable-infos-std-container" }
const _hoisted_27 = { class: "editable-infos-std-container__title" }
const _hoisted_28 = { class: "editable-infos-std-container__std-infos--value" }
const _hoisted_29 = {
  key: 0,
  class: "recommend-edit-buttons"
}
const _hoisted_30 = { class: "announce-modal__content" }
const _hoisted_31 = { class: "announce-modal__content-default--value" }
const _hoisted_32 = { class: "announce-modal-close-button-container" }

import { inject, computed, onMounted, reactive, ref } from 'vue';

import { i18n } from '@/i18n';

import Modal from '@/components/modal/Modal.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { simpleCopy } from '@/utils/deepCopy';
import { FORECAST_LENGTH, FORECAST_LENGTH_IN_MODAL } from '@/coreDomainsModule/constants';
import LeadTimePicker from '@/components/modal/LeadTimePicker.vue';
import StdInventoryPicker from '@/components/modal/StdInventoryPicker.vue';
import { FloatPopupState } from '@/appLogic/interfaces/floatPopup';
import { ISelectFormDataSet } from '@/coreDomainsModule/table';
import { objectEquals } from '@/utils/objectEquals';
import { key } from './useRecommendOrderStore';
import { StdIndexInfo, StdInventoryIndex } from '@/coreDomainsModule/entities/inventory';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';

import { BusinessService } from '../domains/services/businessService';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';
import {
  EditReceiveAnnounceEvent,
  EditableReceiveAnnounceEventKeyNames,
  EditableReceiveAnnounceEventKeys,
} from '../domains/editReceiveAnnounceEvent';
import { calculateDataToDays, daysTocalculateDate } from '@/appLogic/business/businessLogic';
import { TableContentViewModel } from '@/viewModels/tableContent';
import { watch } from 'vue';
import SelectableNumberInput from '@/corePagesModule/components/SelectableNumberInput.vue';
import { SelectableNumberInputOptions } from '@/coreDomainsModule/entities/inputOptions';
import { getLeadTimeForSpanText } from '@/appLogic/business/inventorySimulation';

/**
 * 客先内示編集画面
 */
interface IRecommendEditReceiveAnnounce {
  calculatedAnnounceValues: IAnnounce[];
  leadTime: number;
  stdIndexInfos: StdInventoryIndex;
  leadTimePickerState: FloatPopupState; // リードタイムピッカーの表示状態
  leadTimeSet: ISelectFormDataSet;
  stdInventoryPickerState: FloatPopupState; // 標準在庫指数ピッカーの表示状態
  displayStdIndexInfoSet: StdIndexInfo;
  changedEventHistory: EditReceiveAnnounceEvent[];
  currentEventIndex: number;
  announceAdjustmentOptions: SelectableNumberInputOptions[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendEditReceiveAnnounce',
  props: {
    propCalculatedAnnounceValues: {},
    propLeadTime: {},
    propLeadTimeDisplayValue: { default: 0 },
    propLeadTimeUnit: { default: 'day' },
    propStdIndexInfos: {}
  },
  emits: ["confirmReceiveAnnounce", "reviseReceiveAnnounce"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "785eb53f": (`${state.leadTimePickerState.originCoordinate.y}px`),
  "78509dbe": (`${state.leadTimePickerState.originCoordinate.x}px`),
  "2a3af7ef": (`${state.stdInventoryPickerState.originCoordinate.y}px`),
  "2a2ce06e": (`${state.stdInventoryPickerState.originCoordinate.x}px`),
  "d15f165c": (`repeat(${_unref(FORECAST_LENGTH_IN_MODAL)}, minmax(100px, 1fr))`)
}))

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;

const vm = new TableContentViewModel();

const store = inject(key);

const announceModalState = ref(false);

if (!store) {
  throw new Error('store is undefined');
}
BusinessService;
const state: IRecommendEditReceiveAnnounce = reactive<IRecommendEditReceiveAnnounce>({
  calculatedAnnounceValues: [],
  leadTime: 0,
  stdIndexInfos: {
    min: 0,
    max: 0,
    option: {
      unit: '',
    },
  },
  leadTimePickerState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  leadTimeSet: {
    displayData: -1,
    selectedUnit: 'day',
  },
  stdInventoryPickerState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  displayStdIndexInfoSet: { min: -1, max: 0, name: t('標準在庫指数(詳細ページ)'), unit: 'day' },
  changedEventHistory: [],
  currentEventIndex: -1,
  announceAdjustmentOptions: [],
}) as IRecommendEditReceiveAnnounce;

// イベントフック
onMounted(() => {
  state.calculatedAnnounceValues = simpleCopy(props.propCalculatedAnnounceValues);
  state.leadTime = props.propLeadTime;
  state.stdIndexInfos = simpleCopy(props.propStdIndexInfos);
  state.leadTimeSet.displayData = props.propLeadTimeDisplayValue;
  state.leadTimeSet.selectedUnit = props.propLeadTimeUnit;
  state.displayStdIndexInfoSet = {
    min: state.stdIndexInfos?.min,
    max: state.stdIndexInfos?.max,
    name: t('標準在庫指数(詳細ページ)'),
    unit: state.stdIndexInfos?.option?.unit,
  };
});

// watch

watch(
  () => props.propCalculatedAnnounceValues,
  (newValue) => {
    store.updateDefaultCustomerAnnounceIfNeeded(simpleCopy(newValue));
  }
);

watch(
  () => i18n.locale,
  () => {
    state.announceAdjustmentOptions = [];
    /**
     * 内示調整の倍率の選択肢 0.1 ~ 2.0
     */
    for (let i = 1; i <= 20; i++) {
      const value = i / 10;
      state.announceAdjustmentOptions.push({ text: `${value.toFixed(1)}${t('倍')}`, value });
    }
  },
  { immediate: true }
);

//computed

const canUndo = computed(() => {
  return state.changedEventHistory.length > 0 && state.currentEventIndex >= 0;
});

const canRedo = computed(() => {
  return state.changedEventHistory.length > 0 && state.currentEventIndex < state.changedEventHistory.length - 1;
});

// TODO: implement ↓

/**
 * 変更内容をスタックに保存する関数
 * @param key - 変更内容の項目
 * @param beforeValue - 変更前の値
 * @param afterValue - 変更後の値
 */
const pushEvent = (key: EditableReceiveAnnounceEventKeys, beforeValue: any, afterValue: any) => {
  // 現在のインデックス以降のイベントを削除
  state.changedEventHistory.splice(state.currentEventIndex + 1);
  // 履歴は最大件数まで保存し、それを超えた場合は古いものから削除する
  if (state.changedEventHistory.length >= 10) {
    // TODO: 10は仮置き
    state.changedEventHistory.shift();
  }
  // 変更内容をスタックに保存
  const event = { key, beforeValue, afterValue };
  state.changedEventHistory.push(event);
  // イベントを追加した場合、現在のインデックスは最新を指す
  state.currentEventIndex = state.changedEventHistory.length - 1;
};

/**
 * スタックから指定したインデックスの変更内容を取得する関数
 * @param index - 取得したいイベントのインデックス
 */
const getEvent = (index: number): EditReceiveAnnounceEvent | undefined => {
  return state.changedEventHistory[index];
};

/**
 * 現在の画面に変更内容を反映させる関数
 * @param key - 変更内容の項目
 * @param value - 変更内容
 */
const applyEventValue = (key: EditableReceiveAnnounceEventKeys, value: any) => {
  switch (key) {
    case EditableReceiveAnnounceEventKeyNames.forecast:
      state.calculatedAnnounceValues = value;
      break;
    case EditableReceiveAnnounceEventKeyNames.leadTime:
      state.leadTimeSet = value;
      break;
    case EditableReceiveAnnounceEventKeyNames.standardInventoryIndex:
      state.stdIndexInfos = value;
      break;
    default:
      break;
  }
};

/**
 * Undo(戻る)機能。変更内容を一つ前の更新履歴で上書きする関数
 */
const undo = () => {
  const event = getEvent(state.currentEventIndex);
  if (!event) {
    // indexが範囲外
    console.error('index out of range');
    return;
  }
  applyEventValue(event.key, simpleCopy(event.beforeValue));
  state.currentEventIndex--;
};

/**
 * Redo(進む)機能。変更内容を一つ後の更新履歴で上書きする関数
 */
const redo = () => {
  const event = getEvent(state.currentEventIndex + 1);
  if (!event) {
    // indexが範囲外
    console.error('index out of range');
    return;
  }
  applyEventValue(event.key, simpleCopy(event.afterValue));
  state.currentEventIndex++;
};

/**
 *
 * @param index - a
 * @param newValue - a
 */
const updateAmount = (index, newValue) => {
  if (newValue === state.calculatedAnnounceValues[index].amount) {
    // 変更がない場合は何もしない
    return;
  }
  const oldValue = simpleCopy(state.calculatedAnnounceValues);
  // calculatedAnnounceValuesの特定のインデックスを更新
  state.calculatedAnnounceValues[index].amount = newValue;
  // 変更内容をスタックに保存
  pushEvent(EditableReceiveAnnounceEventKeyNames.forecast, oldValue, simpleCopy(state.calculatedAnnounceValues));
};

/* picker */

/**
 * リードタイムピッカーを開く　FIXME: teleportとか使って、ピッカーを表示したい
 * @param event - ボタンのクリックイベント
 */
const openLeadTimePicker = (event: MouseEvent) => {
  // 2024-1-9 ひとまず、リードタイムピッカーを表示するボタンの位置にピッカーを表示するようにしている
  const leadTimeContent = document.getElementsByClassName('editable-infos-lead-time-container__lead-time')[0] as HTMLElement;
  state.leadTimePickerState.originCoordinate.x = leadTimeContent.offsetLeft;
  state.leadTimePickerState.originCoordinate.y = leadTimeContent.offsetTop + leadTimeContent.offsetHeight;
  state.leadTimePickerState.shouldShow = true;
};
/**
 * リードタイムピッカーを閉じる
 */
const closeLeadTimePicker = () => {
  state.leadTimePickerState.shouldShow = false;
};
/**
 * リードタイムピッカーで選択した値を反映させる
 * @param value - リードタイムピッカーで選択した値
 */
const onConfirmLeadTimePicker = (value: ISelectFormDataSet) => {
  if (
    (value.displayData === state.leadTimeSet.displayData && value.selectedUnit === state.leadTimeSet.selectedUnit) ||
    value.displayData == null
  ) {
    // 変更がない場合 or 空が入力されていた場合は何もしない
    closeLeadTimePicker();
    return;
  }

  const updatedLeadTimeSet: ISelectFormDataSet = {
    displayData: getLeadTimeForSpanText(value.displayData, value.selectedUnit.toString()),
    selectedUnit: value.selectedUnit,
  };

  // シミュレーションに使用するリードタイム値を更新（日数で管理）
  state.leadTime = calculateDataToDays(value);
  // 表示に使用するリードタイム値を更新
  if (updatedLeadTimeSet.displayData) store.changedLeadTimeDisplayValue(updatedLeadTimeSet.displayData);
  // 表示に使用するリードタイムの単位を更新
  if (typeof value.selectedUnit === 'string') store.changedLeadTimeUnit(updatedLeadTimeSet.selectedUnit.toString());
  const oldValue = simpleCopy(state.leadTimeSet);
  state.leadTimeSet = updatedLeadTimeSet;
  pushEvent(EditableReceiveAnnounceEventKeyNames.leadTime, oldValue, simpleCopy(state.leadTimeSet));
  closeLeadTimePicker();
};

/**
 * 標準在庫指数ピッカーを開く FIXME: teleportとか使って、ピッカーを表示したい
 * @param event - ボタンのクリックイベント
 */
const openStdInventoryPicker = (event: MouseEvent) => {
  // 2024-1-9 ひとまず、標準在庫指数ピッカーを表示するボタンの位置にピッカーを表示するようにしている
  const stdInventoryContent = document.getElementsByClassName('editable-infos-std-container__std-infos')[0] as HTMLElement;
  state.stdInventoryPickerState.originCoordinate.x = stdInventoryContent.offsetLeft;
  state.stdInventoryPickerState.originCoordinate.y = stdInventoryContent.offsetTop + stdInventoryContent.offsetHeight;
  state.stdInventoryPickerState.shouldShow = true;
};
/**
 * 標準在庫指数ピッカーを閉じる
 */
const closeStdInventoryPicker = () => {
  state.stdInventoryPickerState.shouldShow = false;
};
/**
 * 標準在庫指数ピッカーで選択した値を反映させる
 * @param value - 標準在庫指数ピッカーで選択した値
 */
const onStdInventoryPicker = (value: StdIndexInfo) => {
  if (value.min === state.stdIndexInfos.min && value.max === state.stdIndexInfos.max && value.unit === state.stdIndexInfos.option.unit) {
    // 変更がない場合は何もしない
    closeStdInventoryPicker();
    return;
  }
  state.displayStdIndexInfoSet = {
    min: value.min,
    max: value.max,
    name: t('標準在庫指数(詳細ページ)'),
    unit: value.unit,
  };
  const oldValue = simpleCopy(state.stdIndexInfos);
  state.stdIndexInfos = {
    min: value.min,
    max: value.max,
    option: {
      unit: value.unit,
    },
  };
  pushEvent(EditableReceiveAnnounceEventKeyNames.standardInventoryIndex, oldValue, simpleCopy(state.stdIndexInfos));
  closeStdInventoryPicker();
};

/**
 * 標準在庫指数ピッカーで選択した値が不正だった場合の処理
 */
const onConfirmedInvalidStdInventoryPicker = () => {
  // TODO: ひとまず変更を適用せずにピッカーを閉じている。アラート出すなどの通知が必要
  closeStdInventoryPicker();
};

/**
 *
 */
const selectLeadtime = () => {};
/**
 *
 */
const selectStdIndexed = () => {};

/**
 *
 */
const onClickConfirmReceiveAnnounce = () => {
  // propsに変化があった | リセットフラグが立った場合に、シミュレーションを更新する
  if (
    !objectEquals(state.calculatedAnnounceValues, props.propCalculatedAnnounceValues) ||
    state.leadTime !== props.propLeadTime ||
    !objectEquals(state.stdIndexInfos, props.propStdIndexInfos)
  ) {
    // 確定発注が存在する場合、最終確定日の翌日の日付を取得し、extraSimulateを更新する
    const lockedRecommend = store.state.recommend.filter((item) => item.isLocked || item.arrivalId != '') ?? [];
    const lockedRecommendLast = lockedRecommend?.[lockedRecommend?.length - 1];

    const startDate = store.calculateStartDate(lockedRecommendLast);

    if (startDate) {
      store.updateExtraSimulate(state.calculatedAnnounceValues, state.stdIndexInfos, state.leadTime, lockedRecommend, startDate);
    } else {
      store.updateExtraSimulate(state.calculatedAnnounceValues, state.stdIndexInfos, state.leadTime);
    }
  }
  emits('confirmReceiveAnnounce');
};

/**
 * 内示調整ボタンクリックの処理
 */
const onClickAnnounceAdjustment = () => {
  store.calcAnnounceAdjustment(state.calculatedAnnounceValues);
};

/**
 * 客先内示記入モーダルを表示する
 */
const onClickAnnounceModalOpenButton = () => {
  announceModalState.value = true;
};

/**
 * 客先内示記入モーダルを閉じる
 */
const onClickAnnounceModalCloseButton = () => {
  announceModalState.value = false;
};

/**
 * 客先内示記入モーダルを閉じる
 */
const closeAnnounceModal = () => {
  announceModalState.value = false;
};

/**
 * 内示調整の倍率が変更された時の処理
 * @param value - 変更された倍率
 */
const onConfirmedAnnounceAdjustmentRate = (value: number) => {
  store.updateAnnounceAdjustmentRate(value);
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('客先内示')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SvgLoader, {
          class: "showing-controller__state-icon--opened",
          "tool-tip-value": _unref(t)('客先内示エリアを閉じる(詳細ページ)'),
          name: 'arrowDownLarge',
          "data-testid": "`showing-controller__opened-arrow`",
          "button-style": 'btn-primary'
        }, null, 8, ["tool-tip-value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(SvgLoader, {
            class: "table-infos-controller-container__sequence-buttons--back",
            name: 'leftArrow',
            "data-testid": "`offered_announce_undo_button`",
            "tool-tip-value": _unref(t)('計算結果を前に戻す(詳細ページ)'),
            "button-style": 'btn-primary',
            disabled: !canUndo.value,
            onClick: undo
          }, null, 8, ["tool-tip-value", "disabled"]),
          _createVNode(SvgLoader, {
            class: "table-infos-controller-container__sequence-buttons--next",
            name: 'rightArrow',
            "data-testid": `offered-announce_undo_button`,
            "tool-tip-value": _unref(t)('計算結果を次に進める(詳細ページ)'),
            disabled: !canRedo.value,
            onClick: redo
          }, null, 8, ["tool-tip-value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            class: "table-infos-controller-container__show-all-announce--text",
            onClick: onClickAnnounceModalOpenButton
          }, _toDisplayString(_unref(t)('全ての月を表示(詳細ページ)')), 1),
          _createVNode(SvgLoader, {
            class: "table-infos-controller-container__show-all-announce--icon",
            "tool-tip-value": _unref(t)('客先内示エリアを閉じる(詳細ページ)'),
            name: 'doubleArrow',
            "data-testid": "`table-infos-controller-container__show-all-announce--icon`",
            "button-style": 'btn-primary'
          }, null, 8, ["tool-tip-value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("thead", _hoisted_11, [
            _createElementVNode("tr", _hoisted_12, [
              _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(t)('')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.calculatedAnnounceValues.slice(0, _unref(FORECAST_LENGTH)), (testObj, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: 'header' + index,
                  class: "announce-table-area__table-head--column"
                }, _toDisplayString(_unref(t)('displayShortDate', {
                    year: _unref(t)(`${testObj.year}`),
                    month: _unref(t)(`${testObj.month}`),
                  })), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_14, [
            _createElementVNode("tr", _hoisted_15, [
              _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(t)('シミュレーション(詳細ページ)')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.calculatedAnnounceValues.slice(0, _unref(FORECAST_LENGTH)), (testObj, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: 'contents' + index,
                  class: "announce-table-area__table-body--column"
                }, [
                  _createVNode(NumberInputWithComma, {
                    "model-value": testObj.amount,
                    class: "announce-table-area__table-body--input-column",
                    "onUpdate:modelValue": ($event: any) => (updateAmount(index, $event))
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]))
              }), 128))
            ]),
            _createElementVNode("tr", _hoisted_17, [
              _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(t)('受領した内示(詳細ページ)')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.defaultCustomerAnnounce.slice(0, _unref(FORECAST_LENGTH)), (testObj, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: 'default' + index,
                  class: "announce-table-area__table-body--column"
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(testObj.amount.addComma()), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_i18n_t, {
          class: "editable-infos-announce-adjustment-container__title",
          keypath: '内示調整(詳細ページ)',
          tag: "span"
        }, {
          newLine: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("br", null, null, -1)
          ])),
          _: 1
        }),
        _createVNode(SelectableNumberInput, {
          "display-value": `${_unref(store).state.announceAdjustmentRate} ${_unref(t)('倍')}`,
          "default-value": _unref(store).state.announceAdjustmentRate,
          options: state.announceAdjustmentOptions,
          class: "editable-infos-announce-adjustment-container__leverage-selector",
          onConfirmed: onConfirmedAnnounceAdjustmentRate
        }, null, 8, ["display-value", "default-value", "options"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('リードタイム')), 1),
        _createElementVNode("div", {
          class: "editable-infos-lead-time-container__lead-time",
          onClick: openLeadTimePicker
        }, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(vm).getDisplayLeadTimeWithUnit(state.leadTimeSet)), 1),
          _createVNode(SvgLoader, {
            class: "editable-infos-lead-time-container__lead-time--selector",
            name: 'arrowDown',
            "data-testid": `offered-announce_undo_button`,
            onClick: selectLeadtime
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)('標準在庫指数')), 1),
        _createElementVNode("div", {
          class: "editable-infos-std-container__std-infos",
          onClick: openStdInventoryPicker
        }, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(vm).getDisplayStdInventory({} as IBusiness, state.stdIndexInfos)), 1),
          _createVNode(SvgLoader, {
            class: "editable-infos-std-container__std-infos--selector",
            name: 'arrowDown',
            "data-testid": `offered-announce_undo_button`,
            onClick: selectStdIndexed
          })
        ])
      ])
    ]),
    _createVNode(LeadTimePicker, {
      class: "lead-time-picker",
      "popup-state": state.leadTimePickerState.shouldShow,
      "lead-time-set": state.leadTimeSet,
      onOnClose: closeLeadTimePicker,
      onOnConfirm: onConfirmLeadTimePicker,
      onOnUpdateLeadTime: _cache[0] || (_cache[0] = (value, unit) => _unref(store).onUpdateDefaultLeadTime(value, unit))
    }, null, 8, ["popup-state", "lead-time-set"]),
    _createVNode(StdInventoryPicker, {
      class: "std-inventory-picker",
      "popup-state": state.stdInventoryPickerState.shouldShow,
      "std-inventory-info": state.displayStdIndexInfoSet,
      onOnClose: closeStdInventoryPicker,
      onOnConfirm: onStdInventoryPicker,
      onOnConfirmedInvalidValue: onConfirmedInvalidStdInventoryPicker,
      onOnUpdateStdInventory: _cache[1] || (_cache[1] = (value) => _unref(store).onUpdateDefaultStdInventoryIndices(value))
    }, null, 8, ["popup-state", "std-inventory-info"]),
    (_unref(store).state.progress === 'EditReceiveAnnounce')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createVNode(TextButton, {
            class: "editable-infos__adjust-announce-button",
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "on-click": onClickAnnounceAdjustment
          }, {
            default: _withCtx(() => [
              _createVNode(_component_i18n_t, {
                keypath: '内示調整倍率を適用(詳細ページ)',
                tag: "p"
              }, {
                newLine: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("br", null, null, -1)
                ])),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createVNode(TextButton, {
            class: "recommend-edit-receive-announce__define-button",
            "button-style": 'btn-primary',
            size: 'btn-md',
            "on-click": onClickConfirmReceiveAnnounce
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('発注計画を作成(詳細ページ)')), 1)
            ], undefined, true),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      "stretch-container": true,
      "modal-title": "直近全ての月の客先内示(詳細ページ)",
      "modal-size": "3xl",
      "border-radius": "16px",
      "modal-state": announceModalState.value,
      onOutsideClick: closeAnnounceModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.calculatedAnnounceValues, (testObj, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'modal-header' + index,
              class: "announce-modal__content-header"
            }, _toDisplayString(_unref(t)('displayShortDate', {
                year: _unref(t)(`${testObj.year}`),
                month: _unref(t)(`${testObj.month}`),
              })), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.calculatedAnnounceValues, (testObj, index) => {
            return (_openBlock(), _createBlock(NumberInputWithComma, {
              key: 'modal-contents' + index,
              "model-value": testObj.amount,
              class: "announce-modal__content-item",
              "onUpdate:modelValue": ($event: any) => (updateAmount(index, $event))
            }, null, 8, ["model-value", "onUpdate:modelValue"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.defaultCustomerAnnounce, (testObj, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'modal-defaults' + index,
              class: "announce-modal__content-default"
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "upper-asterisk-mark" }, "※", -1)),
              _createElementVNode("span", _hoisted_31, _toDisplayString(testObj.amount.addComma()), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(TextButton, {
            class: "announce-modal__close-button",
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "on-click": onClickAnnounceModalCloseButton
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('閉じる')), 1)
            ], undefined, true),
            _: 1
          })
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state"])
  ]))
}
}

})